/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FasciaTariffarioDTO } from './fascia-tariffario-dto';
import { OrdinamentoScolastico } from './ordinamento-scolastico';


export interface SchedaTariffarioDTO { 
    ordinamento?: OrdinamentoScolastico;
    altre_scuole?: boolean;
    la_tua?: boolean;
    fasce?: Array<FasciaTariffarioDTO>;
}



